import React, { useRef } from "react";
import { GradientBorderContainer } from "@src/components/templates/layouts/gradient-border-container/gradient-border-container";
import styles from "./alarm-profile-popover.module.scss";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import { ButtonWithIcon } from "../buttons/button-with-icon/button-with-icon";
import renameIconGreen from "@src/assets/svg/rename-icon-green.svg";
import duplicateIcon from "@src/assets/svg/duplicate-icon.svg";
import deleteRedIcon from "@src/assets/svg/delete-red-icon.svg";
import { getAlarmProfiles } from "@src/cloud-connect/dependency-injection-container/get-alarm-profiles";
import { useClickOutsideListener } from "@src/hooks/use-click-outside-listener";
import { useI18N } from "@src/language/language-context";

interface AlarmProfilePopoverProps {
  profileId: string;
  setLocalCardState: (state: "read" | "edit" | "delete") => void;
  setPopoverIsOpen: (state: boolean) => void;
}

const cssClassName = "alarm-profile-popover";

export const AlarmProfilePopover = ({
  profileId,
  setLocalCardState,
  setPopoverIsOpen,
}: AlarmProfilePopoverProps) => {
  const i18n = useI18N();

  const texts = {
    edit: i18n("modules.alarmProfilePopover.edit"),
    duplicate: i18n("modules.alarmProfilePopover.duplicate"),
    delete: i18n("modules.alarmProfilePopover.delete"),
  };
  const popoverRef = useRef<HTMLDivElement>(null);

  const editAlarmProfile = () => {
    setLocalCardState("edit");
    setPopoverIsOpen(false);
  };

  const duplicateAlarmProfile = (profileId) => {
    getAlarmProfiles().duplicateAlarmProfile(profileId);
    setPopoverIsOpen(false);
  };

  const deleteAlarmProfile = () => {
    setLocalCardState("delete");
    setPopoverIsOpen(false);
  };

  const isButtonDisabledStyling = () => {
    return getAlarmProfiles().getAlarmProfiles().length <= 1
      ? "no-outline-disabled"
      : "";
  };

  const isButtonDisabled = () => {
    return getAlarmProfiles().getAlarmProfiles().length <= 1;
  };

  useClickOutsideListener(popoverRef, () => setPopoverIsOpen(false), true);

  return (
    <div ref={popoverRef} className={styles[cssClassName]}>
      <GradientBorderContainer>
        <div className={styles[`${cssClassName}__inner-wrapper`]}>
          <FlexColumnContainer>
            <ButtonWithIcon
              variant={["no-outline", "color-blue"]}
              fun={() => editAlarmProfile()}
              icon={renameIconGreen}
              text={texts.edit}
            />
            <ButtonWithIcon
              variant={["no-outline", "color-blue"]}
              fun={() => duplicateAlarmProfile(profileId)}
              icon={duplicateIcon}
              text={texts.duplicate}
            />
            <ButtonWithIcon
              variant={["no-outline", "color-red", isButtonDisabledStyling()]}
              fun={() => deleteAlarmProfile()}
              icon={deleteRedIcon}
              text={texts.delete}
              disabled={isButtonDisabled()}
            />
          </FlexColumnContainer>
        </div>
      </GradientBorderContainer>
    </div>
  );
};
